var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"xm-empty"},[_c('el-empty',{attrs:{"image-size":_vm.imageSize,"image":_vm.imageUlr,"description":' '}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }